import React, {Component} from 'react'

import styled from '@emotion/styled'
import sv from '../styles/marketing'
import AuthBase from '../components/AuthBase'
import AuthButton from '../components/AuthButton'
import AuthError from '../components/AuthError'
import AuthFormField from '../components/AuthFormField'

import {connect} from 'react-redux';

import {alertActions, userActions} from '../_actions';

import {withTranslation} from "react-i18next";
import {AnimatedLoader, Container, StyledMedia} from "../styles/CommonStyler";
import {Header} from "../components/Header";
import Footer from "../components/Footer";
import {alertActionTypes} from "../_constants";
import * as queryString from "query-string";
import {isMobileOnly} from "react-device-detect";

// STYLE ##########################################################

const Actions = styled(`div`)`
  margin-top: 24px;
  ${sv.flexRow};
`;

const Options = styled(`div`)`
  ${sv.label};
  text-transform: none;
  margin-top: 24px;
  ${sv.flexCenter};
`;

// COMPONENT ##########################################################

class PasswordReset extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            token: '',
            password: '',
            usernameInUrl: false,
            tokenInUrl: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.showLoader = this.showLoader.bind(this);
    }

    componentDidMount() {
        this.processParams();
    }

    // process the URL and set parameters, if any
    processParams = () => {
        let query = queryString.parse(this.props.location.search);
        if(query){
            if(query.token) { this.setState({token: query.token, tokenInUrl: true}) }
            if(query.email) { this.setState({username: query.email, usernameInUrl: true}) }
        }
    };

    handleChange(e) {
        const {name, value} = e.target;
        this.setState({[name]: value});
    }

    handleSubmit(e) {
        const {t} = this.props;
        e.preventDefault();

        const {username, token, password} = this.state;

        if( !username || !token){
            this.props.dispatchEmptyFieldError({ "errorMsg" : t("Something’s not quite right. Make sure you used the correct link from your reset password email.")} );
        } else if( username && token ){
            if(password === '' || password.length < 6){
                this.props.dispatchEmptyFieldError({ "errorMsg" : t("Sorry, password needs to be at least 6 characters.")} );
            } else {
                this.resetPassword();
            }
        }
    }

    resetPassword() {
        const {username, token, password} = this.state;
        this.props.passwordReset(username, token, password);
    }

    showLoader() {
        const {users} = this.props;
        return (users && users.passwordReset && users.passwordReset.loading);
    };

    render() {
        const {alert, t} = this.props;
        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>

                    <Header/>

                    <AuthBase title={t('Reset Password')+"."}>
                        {
                            alert.type === alertActionTypes.ERROR &&
                            <AuthError error={alert.message.errorMsg}/>
                        }

                        {/* if username is not set */}
                        { !this.state.usernameInUrl &&
                        <AuthFormField
                            label={t('Email')}
                            placeholder='bob@smith.com'
                            update={this.handleChange}
                            name="username"
                            onEnterPressed={this.handleSubmit}
                        />
                        }

                        {/* if password reset token is not set */}
                        { !this.state.tokenInUrl &&
                        <AuthFormField
                            label={t('Token')}
                            placeholder='xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
                            update={this.handleChange}
                            name="token"
                            onEnterPressed={this.handleSubmit}
                        />
                        }

                        <AuthFormField
                            password
                            label={t('New Password')}
                            placeholder={t('Enter password')}
                            update={this.handleChange}
                            name="password"
                            onEnterPressed={this.handleSubmit}
                        />

                        <Actions>
                            <AuthButton onClick={this.handleSubmit} id="submit">{t('Reset Password')}</AuthButton>
                        </Actions>

                        { this.showLoader() &&
                        <Options>
                            <AnimatedLoader color={sv.colors.cta}/>
                        </Options>
                        }
                    </AuthBase>

                    <Footer/>

                </Container>
            </StyledMedia>
        )
    }
}

function mapStateToProps(state) {
    const {users, alert} = state;
    return {
        users, alert
    };
}

function mapDispatchToProps(dispatch) {
    return {
        passwordReset: (username, token, password)  => dispatch(userActions.resetPassword(username, token, password)),
        dispatchEmptyFieldError: (msg)              => dispatch(alertActions.error(msg))
    }
}

const connectedPasswordReset = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PasswordReset));
export {connectedPasswordReset as PasswordReset};